'use client';

import { c as _c } from "react/compiler-runtime";
import { type StaticImport } from 'next/dist/shared/lib/get-img-props';
import { ImageWithFallback, type ImageWithFallbackProps } from '@shared/ui-components/image-with-fallback/image-with-fallback';
import DefaultFallbackImage from './fallback-image.svg';
import { imageLoader } from './image-loader';
type ImageWrapperProps = Omit<ImageWithFallbackProps, 'fallbackSrc'> & {
  fallbackSrc?: StaticImport | string;
  hasDefaultFallback?: boolean;
};
export const ImageWrapper = t0 => {
  const $ = _c(7);
  let fallbackSrc;
  let hasDefaultFallback;
  let rest;
  if ($[0] !== t0) {
    const {
      fallbackSrc: t1,
      hasDefaultFallback: t2,
      quality,
      ...t3
    } = t0;
    fallbackSrc = t1;
    hasDefaultFallback = t2;
    rest = t3;
    $[0] = t0;
    $[1] = fallbackSrc;
    $[2] = hasDefaultFallback;
    $[3] = rest;
  } else {
    fallbackSrc = $[1];
    hasDefaultFallback = $[2];
    rest = $[3];
  }
  const t1 = fallbackSrc ? fallbackSrc : hasDefaultFallback ? DefaultFallbackImage : "";
  let t2;
  if ($[4] !== rest || $[5] !== t1) {
    t2 = <ImageWithFallback {...rest} fallbackSrc={t1} loader={imageLoader} />;
    $[4] = rest;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};